import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
    console.log("Init Sentry with DSN", dsn);
    Sentry.init({
        dsn,

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
        sendDefaultPii: true,

        integrations: [],
        environment: import.meta.env.MODE || "development",
    });
} else {
    console.log("No SENTRY_DSN found, skipping Sentry init");
}
